import React from 'react';

import { Box, Button, Link } from '@mui/material';
import { useL10n } from '@uplift/hooks';
import { Alert } from '@uplift/ui-v2';

import { DisabledActionAlert } from '../../../../components/DisabledActionAlert';


export const GoLiveLockedHelpText = () => {
  const l10n = useL10n();

  return (
    <Box mb={2}>
      <Alert severity="info" title="Going live in a new state is handled by our team">
        Email <Link href={`mailto:${l10n.helpEmail}`}>{l10n.helpEmail}</Link> and we&apos;ll take it from there.
        You can still sign and upload your collaborative agreements below.
      </Alert>
    </Box>
  );
};


export type LockedGoLiveButtonProps = {
  label: string;
  icon: React.ReactNode;
};

export const LockedGoLiveButton: React.FC<LockedGoLiveButtonProps> = ({ label, icon }) => {
  const l10n = useL10n();

  const message = (
    <span>
      Email <Link href={`mailto:${l10n.helpEmail}`} color="inherit">{l10n.helpEmail}</Link> to go live in another state.
    </span>
  );

  const tooltip = `Email ${l10n.helpEmail} to go live in another state.`;

  return (
    <DisabledActionAlert message={message} tooltip={tooltip}>
      <Button variant="contained" color="secondary" size="small" startIcon={icon} disabled>
        {label}
      </Button>
    </DisabledActionAlert>
  );
};
